/**
 * Yeniden değerlendirme ekranının "Diğer filtreler" alanları — çubukta kendi düğmesi olmayan, sol panelde
 * (ReAssessmentFilter) duran filtreler. Alan tanımının biçimi: bkz. quick-filter/ExtraFilters. Sıra paneldeki sıradır.
 *
 * Tarih türü/aralığı, sonuç ve modalite çubuğun kendi bloklarında olduğu için burada yok.
 * Hastane grubu panelde yetkisiz gösteriliyor (rapor ekranının aksine) — aynısı korunuyor.
 */
export const RE_ASSESSMENT_EXTRA_FIELDS = [
    { key: 'originalReadUserId', label: 'Original Read User', kind: 'user', source: 'readableUsers', userType: 'read', empty: undefined },
    { key: 'assignedUserId', label: 'Assigned Doctor', kind: 'user', source: 'readableUsers', userType: 'read', empty: undefined },
    { key: 'patientName', label: 'Patient Name', kind: 'text', empty: undefined },
    { key: 'patientId', label: 'Patient Id', kind: 'text', empty: undefined },
    { key: 'accessionNumber', label: 'Accession Number', kind: 'text', empty: undefined },
    { key: 'hospitalGroupIdList', label: 'Hospital Groups', kind: 'lookup', source: 'hospitalGroups', empty: [] },
    { key: 'hospitalIdList', label: 'Hospital', kind: 'lookup', source: 'hospitals', empty: [] },
    // Sunucu da yetkisizse bu alanı yok sayıyor (ReAssessmentQuery.Build).
    { key: 'institutions', label: 'Institution', kind: 'lookup', source: 'institutions', empty: [], permissions: ['VIEW_STUDY_INSTITUTION'] },
];
